import { render, staticRenderFns } from "./assistant-chat-log.vue?vue&type=template&id=ed256e92&scoped=true"
import script from "./assistant-chat-log.vue?vue&type=script&lang=js"
export * from "./assistant-chat-log.vue?vue&type=script&lang=js"
import style0 from "./assistant-chat-log.vue?vue&type=style&index=0&id=ed256e92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed256e92",
  null
  
)

export default component.exports